import clsx from 'clsx';

/** A state at a glance beside a heading: "On" / "Off", "Set" / "Not set". */
export function StatusBadge({ isOn, label }: { isOn: boolean; label: string }) {
  return <span className={clsx('rounded-full px-2 py-0.5 text-xs font-medium', isOn ? 'bg-success/10 text-success' : 'bg-muted/10 text-muted')}>{label}</span>;
}
